/**
 * @generated SignedSource<<f3b6099f4fa4794533720d4823f5bf77>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AttachmentForm_InfectopharmFileAttachmentFragment$data = {
  readonly attachmentType: string | null | undefined;
  readonly description: string | null | undefined;
  readonly file: {
    readonly id: string;
  } | null | undefined;
  readonly id: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "AttachmentForm_InfectopharmFileAttachmentFragment";
};
export type AttachmentForm_InfectopharmFileAttachmentFragment$key = {
  readonly " $data"?: AttachmentForm_InfectopharmFileAttachmentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachmentForm_InfectopharmFileAttachmentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AttachmentForm_InfectopharmFileAttachmentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attachmentType",
      "storageKey": null
    }
  ],
  "type": "InfectopharmFileAttachment",
  "abstractKey": null
};
})();

(node as any).hash = "885417fc26b71c38476724afcf91991e";

export default node;
